import React, { useEffect, useState } from "react";
import s from "./OrdersModal.module.css";

import {
  Grid,
  Modal,
  TextField,
  Button,
  InputAdornment,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { useTranslation } from "react-i18next";
import ProvidersModal from "../../../Shared/ProvidersModal";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";

const OrdersSearch = ({
  setPage,
  open,
  setOpen,
  setSearching,
  setFilters,
  filters,
  setNewFilters,
}) => {
  const { t } = useTranslation();
  const { allGameOffersActive } = useSelector((state) => state.gamma);

  const [openProvider, setOpenProvider] = useState(false);
  const [providerSelect, setProviderSelect] = useState({
    businessName: t("provider"),
  });

  useEffect(() => {
    if (providerSelect.id) {
      setFilters((prev) => ({ ...prev, supplierId: providerSelect.id }));
    }
  }, [providerSelect]);

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid item xs={10} className={s.exit}>
            <div className={s.titleModal}>
              <p>{t("filter")}</p>
              <span>{t("filterConfig")}</span>
            </div>
            <CloseIcon
              onClick={() => setOpen(false)}
              className={s.exitIcon}
              sx={{ color: "primary.dark" }}
            />
          </Grid>

          <Grid container item xs={12} className={s.filters}>
            <Grid item xs={8} my={3}>
              <TextField
                label={t("orderNumber")}
                type="number"
                variant="outlined"
                sx={{ width: "100%" }}
                helperText={t("paramsIgnore")}
                onChange={(e) => {
                  setFilters((prev) => ({
                    ...prev,
                    orderId: e.target.value * 1,
                  }));
                }}
              />
            </Grid>

            <Grid item xs={8} mb={3}>
              <TextField
                id="input-with-icon-textfield"
                value={providerSelect?.businessName}
                sx={{ cursor: "pointer", width: "100%" }}
                onClick={() => setOpenProvider(true)}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ cursor: "pointer" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {filters.supplierId !== 0 ? (
              <Grid item xs={8} my={3}>
                <FormControl fullWidth>
                  <InputLabel id="game-selector">{t("game")}</InputLabel>
                  <Select
                    labelId="game-selector"
                    value={filters.gameId}
                    label={t("game")}
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        gameId: e.target.value,
                      }))
                    }
                  >
                    <MenuItem value={0}>{t("select")}</MenuItem>
                    {allGameOffersActive?.map((game, i) => (
                      <MenuItem key={i} value={game?.modality?.game?.id}>
                        {game?.modality?.game?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            ) : null}
          </Grid>

          <Grid
            item
            xs={10}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              my: "20px",
              cursor: "not-allowed",
            }}
          >
            <Button
              variant="contained"
              onClick={() => {
                setNewFilters(filters);
                setPage(1);
                setSearching(true);
                setOpen(false);
              }}
            >
              {t("apply")}
            </Button>
          </Grid>
        </Grid>
        {openProvider ? (
          <ProvidersModal
            open={openProvider}
            setOpen={setOpenProvider}
            selectProvider={setProviderSelect}
          />
        ) : null}
      </Grid>
    </Modal>
  );
};

export default OrdersSearch;
